import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [orgInfo, setOrgInfo] = useState(null);

  const loadOrg = useCallback(async () => {
    try { setOrgInfo((await api.get("/org")).data); } catch (_) { setOrgInfo(null); }
  }, []);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadOrg();
    } catch (_) { setUser(false); }
  }, [loadOrg]);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    await loadOrg();
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    await loadOrg();
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setOrgInfo(null);
  };

  return (
    <AuthCtx.Provider value={{ user, orgInfo, login, register, logout, reload: loadMe, reloadOrg: loadOrg, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
